import redirect from '../../utils/redirect'
import {
  APP_LAUNCH_TITLE,
  APP_LAUNCH_ACTION,
  APP_LAUNCH_FOOTNOTE
} from '../../constants/ui.labels'
import { constantBuilder } from '../../utils'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import { Icon } from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import Link from '@talkdesk/cobalt-react-link'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const AppLauncher = ({ name, launchUrl }) => {
  const theme = useTheme()

  return (
    <Flex direction="column" alignX="center" gap={6} paddingBottom={6}>
      <Icon name="devices" size="large" color={theme.primary600} />
      <Flex direction="column" alignX="center" gap={3}>
        <Heading level={1}>
          {constantBuilder(APP_LAUNCH_TITLE, { client_name: name })}
        </Heading>
        <Text size="small" color={theme.gray600}>
          {constantBuilder(APP_LAUNCH_FOOTNOTE, { client_name: name })}{' '}
          <Link target="_blank" onClick={() => redirect(launchUrl)}>
            {APP_LAUNCH_ACTION}
          </Link>
        </Text>
      </Flex>
    </Flex>
  )
}

export default AppLauncher
